/** @format */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'homefield-skeleton-product-card',
  templateUrl: './skeleton-product-card.component.html',
  styleUrl: './skeleton-product-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldSkeletonProductCardComponent {
  @Input() compareCheckboxEnabled = false;
}
